export const GO_FORWARD = '@@onboarding/GO_FORWARD'
export const GO_BACK = '@@onboarding/GO_BACK'
export const SKIP_TO = '@@onboarding/SKIP_TO'
export const CLOSE = '@@onboarding/CLOSE'
